import VerticalGamesHero from './classes/verticals/VerticalGamesHero';
import VerticalConsumer from "./classes/verticals/VerticalConsumer";
import PortfolioComponent from "./classes/components/portfolio/PortfolioComponent";
import VerticalGrowth from "./classes/verticals/VerticalGrowth";
import VerticalSeed from "./classes/verticals/VerticalSeed";
import VerticalFintechHero from "./classes/verticals/VerticalFintechHero";
import VerticalBioHealth from "./classes/verticals/VerticalBioHealth";
import VerticalTxo from "./classes/verticals/VerticalTxo";
import VerticalGames from "./classes/verticals/VerticalGames";
import VerticalTeamComponentFilter from "./classes/verticals/VerticalTeamComponentFilter";
import VerticalFeaturedContentComponentLatest from "./classes/verticals/VerticalFeaturedContentComponentLatest";
import VerticalClf from "./classes/verticals/VerticalClf";
import VerticalGrowthExecutive from "./classes/verticals/VerticalGrowthExecutive";
import VerticalEnterprise from "./classes/verticals/VerticalEnterprise";
import VerticalAmericanDynamism from "./classes/verticals/VerticalAmericanDynamism";
import pageBioFuture from "./classes/verticals/PageBioFuture";
import VerticalInfra from "./classes/verticals/VerticalInfra";
import Growth from "./classes/verticals/Growth";

document.addEventListener('DOMContentLoaded', () => {
    const gamesHero = document.getElementById('games-hero-canvas');

    if(gamesHero) {
        const verticalGamesHero = new VerticalGamesHero(gamesHero);
    }

    const verticalEnterprise = document.querySelector('.page-enterprise');
    if(verticalEnterprise) {
        new VerticalEnterprise();
    }

    const consumerPage = document.querySelector('.consumer-microsite-page');
    if(consumerPage) {
        new VerticalConsumer();
    }

    const bioHealthPage = document.querySelector('.bio-health-microsite-page');
    if(bioHealthPage) {
        new VerticalBioHealth();
    }
    const portfolioComponents = document.querySelectorAll('[data-portfolio-component]');
    if(portfolioComponents.length) {
        portfolioComponents.forEach(portfolioComponent => {
            new PortfolioComponent(portfolioComponent);
        });
    }

    const teamComponentFilter = document.querySelector('[data-team-component-filter]')
    if(teamComponentFilter) {
        new VerticalTeamComponentFilter(teamComponentFilter);
    }

    const featuredContentComponentLatest = document.querySelector('[data-featured-content-component-latest]')
    if(featuredContentComponentLatest) {
        new VerticalFeaturedContentComponentLatest(featuredContentComponentLatest)
    }

    const fintechHero = document.querySelector('.fintech-hero-canvas');
    if(fintechHero) {
        new VerticalFintechHero(fintechHero)
    }

    const growthPageEl = document.querySelector('.growth-microsite-content');
    if(growthPageEl) {
        new VerticalGrowth();
    }

    const growthExecPageEl = document.querySelector('.exec-hiring');
    if(growthExecPageEl) {
        new VerticalGrowthExecutive();
    }

    const seedPageEl = document.querySelector('.seed-page');
    if(seedPageEl) {
        new VerticalSeed();
    }

    const txoPageEl = document.querySelector('.txo-microsite-page');
    if(txoPageEl) {
        new VerticalTxo();
    }

    const gamesPageEl = document.querySelector('.games-page');
    if(gamesPageEl) {
        new VerticalGames(gamesPageEl);
    }

    const clfPageEl = document.querySelector('.template-clf');
    if(clfPageEl) {
        new VerticalClf()
    }

    const adPageEl = document.querySelector('.page-american-dynamism');
    if(adPageEl) {
        new VerticalAmericanDynamism();
    }

    const pageBioFutureEl = document.querySelector('.bio-health-microsite-page.future-is-health');
    if(pageBioFutureEl) {
        new pageBioFuture();
    }

    const pageInfraEl = document.querySelector('.page-infra');
    if(pageInfraEl) {
        new VerticalInfra();
    }

    const growthPageEl_v2 = document.querySelector('.page-growth-v2');
    if(growthPageEl_v2) {
        new Growth();
    }
});
